module.exports = __webpack_public_path__ + "static/media/bg-1.37d0ca7.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/tw/pc/vedio/bg-1.webm
// module id = ymwL
// module chunks = 13